import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classNames from 'classnames';
import { RiCloseLine } from 'react-icons/ri';
import { AvailabilityStatusType } from 'services/types';

interface Props {
	status: AvailabilityStatusType;
	marginSmall?: boolean;
}

export const AvailabilityStatusBubble = (props: Props) => {
	const classes = useStyles();
	const { status, marginSmall } = props;

	const bubbleClasses = classNames(classes.bubble, {
		[classes.unavailable]: status === 'unavailable',
		[classes.available]: status === 'available',
		[classes.low]: status === 'low',
		[classes.loading]: status === 'loading',
		[classes.smallMargin]: marginSmall,
	});

	return (
		<div className={bubbleClasses}>
			{status === 'unavailable' && <RiCloseLine size={15} color="white" />}
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		bubble: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '17px',
			height: '17px',
			borderWidth: '1px',
			margin: theme.spacing(0, 2, 0, 1),
			border: 'solid',
			borderRadius: '50%',
			backgroundColor: 'lightgray',
			borderColor: 'gray',
			transition: 'all 0.2s ease',
		},
		smallMargin: {
			marginRight: theme.spacing(1.5),
			marginTop: theme.spacing(0.25),
			marginLeft: 0,
		},
		available: {
			backgroundColor: theme.palette.colors.availabilityGood.main,
			borderColor: theme.palette.colors.availabilityGood.dark,
		},
		unavailable: {
			backgroundColor: theme.palette.colors.availabilityNone.main,
			borderColor: theme.palette.colors.availabilityNone.dark,
		},
		loading: {
			backgroundColor: theme.palette.background.secondary,
			borderColor: theme.palette.background.secondary,
		},
		low: {
			backgroundColor: theme.palette.colors.availabilityLow.main,
			borderColor: theme.palette.colors.availabilityLow.dark,
		},
	}),
);

export default AvailabilityStatusBubble;
